import React, { FC, useEffect } from 'react'
import { Loading } from '@pandiafi/design-system'
import { useNavigate } from 'react-router-dom'

import { sleep } from '../../../utils'
import routePath from '../../../router/routePath'
import { LoginViewError } from '../../Login/LoginViewTypes'
import { RegistrationState } from './index'

interface Props {
  authType: RegistrationState['authType']
  teliaLink: string
  loading: boolean
}

export const RegisterRedirect: FC<Props> = ({
  loading,
  teliaLink,
  authType,
}) => {
  const navigate = useNavigate()
  useEffect(() => {
    const f = async () => {
      if (loading) return

      // Wait for 1 second to mitigate the flickering of the loading screen
      await sleep(1000)

      if (authType === 'telia' && teliaLink) {
        window.location.assign(teliaLink)
      } else {
        navigate(routePath.logout, {
          state: {
            error: LoginViewError.REGISTRATION_LINK_FETCH_FAILED,
          },
        })
      }
    }
    f()
  }, [authType, teliaLink, loading, navigate])

  return <Loading variant="details" className="my-10" />
}
